type MouseEventTypes =
  | 'contextmenu'
  | 'mousedown'
  | 'mouseenter'
  | 'mouseleave'
  | 'mousemove'
  | 'mouseout'
  | 'mouseover'
  | 'mouseup'
  | 'click'
  | 'dblclick';
type TouchEventTypes = 'touchstart' | 'touchmove' | 'touchend' | 'touchcancel';

/**
 * Detect if event was thrown by the SDK
 *
 * @param {Object} event CustomEvent
 * @returns {Boolean}
 */
export function isEventFromSDK(event: any) {
  return typeof event.detail === 'string';
}

/**
 * Listen for SDK events
 *
 * @param {string} name event name
 * @param {EventHandler} listener function
 * @returns {null}
 */
export function addSDKEventListener(name: string, listener: any) {
  window.addEventListener(name, (e: Event) => {
    if (isEventFromSDK(e)) {
      listener(e);
    }
  });
}

/**
 * Listen for DOM events
 *
 * @param {MouseEventTypes | TouchEventTypes} name event name
 * @param {EventHandler} listener function
 * @returns {null}
 */
export function addDOMEventListener(
  name: MouseEventTypes | TouchEventTypes,
  listener: any
) {
  window.addEventListener(name, (e: Event) => {
    if (!isEventFromSDK(e)) {
      listener(e);
    }
  });
}

export function extractZoneFromElem(
  elem: any,
  attributeName: string = 'data-zone'
): string {
  if (!elem) {
    return 'unknown';
  }
  return (
    elem.getAttribute(attributeName) ||
    extractZoneFromElem(elem.parentElement, attributeName)
  );
}
